import React from 'react';
import {observer} from "mobx-react";
import styled from "styled-components";
import {useServices} from "../../../hooks/use-services.hook";


const SideMenuContentBox = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    font-size: ${props => props.theme.fontSize.h3};
    font-weight: ${props => props.theme.fontWeight.semiBold};
    padding: ${props => props.theme.spacing.spacing16} ${props => props.theme.spacing.spacing8};
`


const MenuItemBox = styled.div`
    cursor: pointer;
    padding: ${props => props.theme.spacing.spacing16};
    &:hover {
        background-color: ${props => props.theme.colors.lightTint};
        border-radius: ${props => props.theme.border.defaultRadius};
    }
`

const MenuItemComponent: React.FC<{label: string; action: () => void}> = observer((props) => {
    const services = useServices();
    const sideMenuController = services.sideMenu.agencyMainSideMenuController;
    const onClick = async () => {
        props.action();
        await sideMenuController.close();
    }

    return (
        <MenuItemBox onClick={onClick}>
            {props.label}
        </MenuItemBox>
    )
})

export const AgencySideMenuContent: React.FC = observer(() => {
    const services = useServices();
    return (
        <SideMenuContentBox>
            <MenuItemComponent label={services.language.translate('Book now')} action={() => services.navigator.goHome()}/>
            <MenuItemComponent label={services.language.translate('Search booking')} action={() => services.navigator.routes.agency.bookingSearch.activate()}/>
            <MenuItemComponent label={services.language.translate('Recent bookings')} action={() => services.agencyBookingSearch.goToRecentBookings()}/>
            <MenuItemComponent label={services.language.translate('Profile')} action={() => services.navigator.routes.agency.profile.activate()}/>
        </SideMenuContentBox>
    )
})